import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import CloseIcon from '@mui/icons-material/Close';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { IoTriangleOutline } from "react-icons/io5";
import { GrEmptyCircle } from "react-icons/gr";
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
const MockTestReadingQuiz = () => {
    const location = useLocation();
    // const navigate = useNavigate();
    const [selectedOption, setSelectedOption] = useState(null);
    const [isCorrect, setIsCorrect] = useState(null);
    const [timer, setTimer] = useState(0); // Start timer from 0
    const [activePage, setActivePage] = useState("Learning");
    // Controls submit and option state
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true); // (reserved – currently not used for options)
    const navigate = useNavigate();
    const [showResultButtons, setShowResultButtons] = useState(false); // Control when to show the new buttons
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null); // Track whether the answer is correct
    const [explanation, setExplanation] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [quizData, setQuizData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeSpent, setTimeSpent] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showSubmitMessage, setShowSubmitMessage] = useState(false);
    const [attemptStatus, setAttemptStatus] = useState(null);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const [attemptstatus22, setAttemptStatus22] = useState();
    const [attemptedQuestions, setAttemptedQuestions] = useState(0);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [language, setLanguage] = useState('english');
    const [text, setText] = useState({});
    const swingAnimRef = useRef();
    const authToken = localStorage.getItem("AuthToken");
    const [loading, setLoading] = useState(false);
    const unAttemptCountRef = useRef(0);
    const [submittedQuestions, setSubmittedQuestions] = useState(new Set());
    const { Translate } = useContext(ProductContext);
    const {
        skippedCount,
        setSkippedCount,
        correctCount,
        setCorrectCount,
        incorrectCount,
        setIncorrectCount,
        resetQuizData,
    } = useContext(ProductContext);

    const categoryData = location.state; // Receive the state passed during navigation
    const category_id = categoryData?.category_id; // Match property name
    const categoryName = categoryData?.categoryName; // Match property name
    const level_id = categoryData?.level_id; // Match property name
    const exam_id = categoryData?.exam_id;
    const test_name_id = categoryData?.test_name_id;
    const question_type_id = categoryData?.question_type_id;
    const total_time_spent = categoryData?.total_time_spent || 0; // Provide default value
    const { quizTypeId, quizName } = location.state || {};

    const [isAiModalOpen, setIsAiModalOpen] = useState(false);
    const [aiLanguage, setAiLanguage] = useState("english"); // 'english' or 'hindi'
    const [aiDisplayedText, setAiDisplayedText] = useState("");

    console.log(quizName, "quizName Reading")




    useEffect(() => {
        const postTimeSpent = async () => {
            const total_time_spent_ms = total_time_spent * 1000;
            const timerData = {
                level_id: level_id,
                category_id: category_id,
                total_time_spent: total_time_spent_ms,
            };
            try {
                const response = await axios.post(
                    `https://api.japaking.online/api/userQuizTime`,
                    timerData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );
            } catch (err) {
                if (err.response && err.response.status === 401) {
                    console.log('navigate to login due to 401');
                    navigate('/');
                }
                console.log('Error submitting time spent data:', err);
            }
        };

        postTimeSpent();
    }, [category_id, level_id, total_time_spent]);
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = await localStorage.getItem('selectedLanguage');
                setLanguage(storedLanguage || 'english');
            } catch (error) {
                console.error('Error loading language:', error);
            }
        };

        loadLanguage();
    }, []);



    useEffect(() => {
        const timer = setInterval(() => {
            setTimeSpent(prevTime => prevTime + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const loadNextPage = async () => {
            if (location.state?.loadNextSet) {
                resetQuizData();
                setAttemptStatus22(undefined);
                setQuizData([]);
                await fetchQuizData(currentPage + 1); // Pass the next page directly
                setCurrentPage(prevPage => prevPage + 1);
            } else {
                fetchQuizData(currentPage); // Fetch current page's data
            }
        };

        loadNextPage(); // Call the function inside useEffect
    }, [location.state]); // Remove `currentPage` from dependencies



    useEffect(() => {
        fetchQuizData(currentPage);
    }, [currentPage]);
    const fetchQuizData = useCallback(async (page) => {
        setIsLoading(true);
        try {
            const isFilteredReadingFlow =
                Boolean(category_id) &&
                Boolean(exam_id) &&
                Boolean(test_name_id) &&
                Boolean(question_type_id);

            const response = await axios.get(
                isFilteredReadingFlow
                    ? `https://api.japaking.online/api/categories/questions/filter?page=${page}&size=6&category_id=${category_id}&exam_id=${exam_id}&test_name_id=${test_name_id}&question_type_id=${question_type_id}`
                    : `https://api.japaking.online/api/categories/${category_id}?page=${page}&size=6`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.data.success) {
                const newQuestions = isFilteredReadingFlow
                    ? response?.data?.message?.questions || []
                    : response?.data?.message?.category?.questions || [];
                setQuizData(newQuestions);
                if (newQuestions.length < 6) {
                    setHasMoreQuestions(false);
                }
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                navigate('/');
            }
            console.log('Error submitting user attempt:', err);
        } finally {
            setIsLoading(false);
            setIsLoadingImage(false);
        }
    }, [category_id, authToken, navigate, exam_id, test_name_id, question_type_id]);
    useEffect(() => {
        // Reset states
        setSkippedCount(0);
        setCorrectCount(0);
        setIncorrectCount(0);
        setAttemptStatus22(undefined);
        setSelectedOption(null);
        setCurrentQuestionIndex(0);
        setQuizData([]);
        setAttemptedQuestions(0);
        setIsOptionSelected(false);
        setShowSubmitMessage(false);
        fetchQuizData(currentPage);
        return () => {
        };
    }, [currentPage, fetchQuizData]);
    // const formatTime = (timeInSeconds) => {
    //     const minutes = Math.floor(timeInSeconds / 60);
    //     const seconds = timeInSeconds % 60;
    //     return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    // };


    const speakText = (text, lang) => {
        if (!text) {
            return;
        }
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = lang;
            window.speechSynthesis.speak(utterance);
        } else {
            alert("Speech Synthesis not supported in your browser.");
        }
    };

    const isJapaneseChar = (char) => {
        const code = char.charCodeAt(0);
        // Hiragana, Katakana, CJK Unified Ideographs (Kanji)
        return (
            (code >= 0x3040 && code <= 0x309F) || // Hiragana
            (code >= 0x30A0 && code <= 0x30FF) || // Katakana
            (code >= 0x4E00 && code <= 0x9FFF)    // Kanji
        );
    };

    const speakHindiExplainWithJapanese = (text) => {
        if (!text) return;
        if (!("speechSynthesis" in window)) {
            alert("Speech Synthesis not supported in your browser.");
            return;
        }

        const segments = [];
        let current = "";
        let currentLang = null;

        for (let i = 0; i < text.length; i += 1) {
            const ch = text[i];
            const isJa = isJapaneseChar(ch);
            const langForChar = isJa ? "ja-JP" : "hi-IN";

            if (currentLang === null) {
                currentLang = langForChar;
                current = ch;
            } else if (langForChar === currentLang) {
                current += ch;
            } else {
                segments.push({ text: current, lang: currentLang });
                currentLang = langForChar;
                current = ch;
            }
        }

        if (current) {
            segments.push({ text: current, lang: currentLang });
        }

        if (segments.length === 0) {
            return;
        }

        window.speechSynthesis.cancel();
        segments.forEach((segment) => {
            const utterance = new SpeechSynthesisUtterance(segment.text);
            utterance.lang = segment.lang;
            window.speechSynthesis.speak(utterance);
        });
    };

    const renderWithBold = (text) => {
        if (!text) return null;
        const parts = text.split("**");
        return parts.map((part, index) =>
            index % 2 === 1 ? <strong key={index}>{part}</strong> : part
        );
    };

    const openAiModal = () => {
        const currentQuestion = quizData[currentQuestionIndex];
        if (!currentQuestion) return;
        if (!currentQuestion.ai_english_explain && !currentQuestion.ai_hindi_explain) return;
        setAiLanguage(currentQuestion.ai_english_explain ? "english" : "hindi");
        setIsAiModalOpen(true);
    };

    const closeAiModal = () => {
        setIsAiModalOpen(false);
        if ("speechSynthesis" in window) {
            window.speechSynthesis.cancel();
        }
    };

    useEffect(() => {
        if (!isAiModalOpen) {
            setAiDisplayedText("");
            return;
        }

        const current = quizData[currentQuestionIndex];
        if (!current) {
            setAiDisplayedText("");
            return;
        }

        const fullText =
            aiLanguage === "english"
                ? current.ai_english_explain
                : current.ai_hindi_explain;

        if (!fullText) {
            setAiDisplayedText("");
            return;
        }

        setAiDisplayedText("");
        let index = 0;
        const intervalId = setInterval(() => {
            index += 1;
            setAiDisplayedText(fullText.slice(0, index));
            if (index >= fullText.length) {
                clearInterval(intervalId);
            }
        }, 5);

        return () => clearInterval(intervalId);
    }, [isAiModalOpen, aiLanguage, currentQuestionIndex, quizData]);

    const handleSelect = optionId => {
        setSelectedOption(optionId);
        setShowSelectAnswerMessage(false);
        setIsSubmitDisabled(false); // allow submit once an option is chosen
    };
    const submitUserAttempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        if (submittedQuestions.has(currentQuestion.question_id)) {
            return;
        }
        setSubmittedQuestions(prev =>
            new Set(prev).add(currentQuestion.question_id),
        );
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );

        const attemptStatus = selectedOption
            ? selectedOptionData?.is_correct
                ? 'correct'
                : 'incorrect'
            : 'skipped';

        if (attemptStatus === 'correct') {
            setCorrectCount(prev => prev + 1);
        } else if (attemptStatus === 'incorrect') {
            setIncorrectCount(prev => prev + 1);
        } else if (attemptStatus === 'skipped') {
            setSkippedCount(prev => prev + 1);
        }

        const userAttemptData = {
            questionId: currentQuestion.question_id,
            optionId: selectedOption || null,
            attemptStatus,
        };
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
    };

    const [showSelectAnswerMessage, setShowSelectAnswerMessage] = useState(false);

    // const handleSubmitAnswer = async () => {
    //     if (!selectedOption) {
    //         setShowSelectAnswerMessage(true);
    //         return;
    //     }
    const handleSubmit = async () => {
        if (!selectedOption) {
            setShowSelectAnswerMessage(true); // Show message if no option is selected
            return;
        }

        await submitUserAttempt(); // Submit the user attempt to the backend

        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption
        );

        // Update the correctness and show the result buttons
        const answerCorrect = selectedOptionData?.is_correct || false;
        setIsCorrect(answerCorrect);
        setShowResultButtons(true); // Show the result buttons
        setIsSubmitted(true);
    };


    const handleNextQuestion = () => {
        const isEndOfSet = (currentQuestionIndex + 1) % 6 === 0; // End of a set of 6 questions
        const isLastQuestion = currentQuestionIndex === quizData.length - 1; // Last question in quiz

        if (isLastQuestion) {
            // Navigate to the Results screen when it's the last question
            navigate('/learning-quiz-result', {
                state: {
                    correctCount,
                    incorrectCount,
                    skippedCount,
                    category_id,
                    level_id,
                    categoryName,
                    total_time_spent,
                    quizTypeId,
                    quizName
                },
            });
        } else if (isEndOfSet && hasMoreQuestions) {
            // End of a set but there are more questions (e.g., next pagination)
            setCorrectCount(0);
            setIncorrectCount(0);
            setSkippedCount(0);
            setCurrentPage(nextPage => nextPage + 1);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
        } else if (isEndOfSet) {
            // End of set with no more questions, navigate to results
            navigate('/learning-quiz-result', {
                state: {
                    correctCount,
                    incorrectCount,
                    skippedCount,
                    category_id,
                    level_id,
                    categoryName,
                    total_time_spent,
                    quizTypeId,
                    quizName
                },
            });
        } else {
            // Move to the next question
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
        }
    };
    const currentQuestion = quizData[currentQuestionIndex];
    const progress22 = `${currentQuestionIndex + 1}/${quizData.length}`;
    const progressPercentage = ((currentQuestionIndex + 1) / quizData.length) * 100;
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };
    // const progressWidth = ((currentQuestion + 1) / questions.length) * 100;
    const handleMoveToQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            navigate('/take-quiz', {
                state: { categoryId: category_id },
            });
        } else {
            navigate('thank-you-quiz', {
                state: {
                    categoryId: category_id,
                    total_time_spent: timeSpent
                },
            });
        }
        setShowSubmitMessage(false);
    };
    const handleStartNewQuiz = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        const isLastQuestion = currentQuestionIndex === quizData.length - 1;
        const isEndOfSet =
            (currentQuestionIndex + 1) % 6 === 0 || !hasMoreQuestions;

        if (isEndOfSet || isLastQuestion) {
            navigate('/learning-quiz-result', {
                state: {
                    category_id,
                    level_id,
                    categoryName,
                    total_time_spent: timeSpent,
                    correctCount,
                    incorrectCount,
                    skippedCount,
                    quizTypeId,
                    quizName
                },
            });
        } else if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else if (hasMoreQuestions) {
            setCurrentPage(nextPage => nextPage + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else {
            navigate('FinishQuiz', {
                category_id,
                total_time_spent: timeSpent,
            });
        }
    };


    // const handleSkip = async () => {
    //     const currentQuestion = quizData[currentQuestionIndex];

    //     const userAttemptData = {
    //         questionId: currentQuestion.question_id,
    //         attemptStatus: 'un_attempt',
    //     };

    //     setSkippedCount((prev) => prev + 1);

    //     try {
    //         setLoading(true);
    //         const response = await axios.post(
    //             `https://api.japaking.online/api/userAttempts`,
    //             userAttemptData,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Bearer ${authToken}`,
    //                 },
    //             }
    //         );
    //         setAttemptStatus(response.data.message.attempt.attempt_status);
    //         setAttemptStatus22(response?.data?.message);
    //     } catch (err) {
    //         if (err.response?.status === 401) {
    //             console.log('Navigate to login due to 401');
    //             navigate('/');
    //         }
    //         console.error('Error submitting user attempt in handleSkip:', err);
    //     } finally {
    //         setLoading(false);
    //     }

    //     const isLastQuestion = currentQuestionIndex === quizData.length - 1;
    //     const isEndOfSet =
    //         (currentQuestionIndex + 1) % 6 === 0 || !hasMoreQuestions;

    //     if (isEndOfSet || isLastQuestion) {
    //         navigate('/learning-quiz-result', {
    //             state: {
    //                 correctCount: 0,
    //                 incorrectCount: 0,
    //                 category_id,
    //                 level_id,
    //                 categoryName,
    //                 total_time_spent,
    //                 skippedCount: skippedCount + 1
    //             },
    //         });
    //     } else {
    //         handleNextQuestion();
    //     }
    // };
    const handleSkip = async () => {
        if (!quizData || quizData.length === 0) {
            console.error("Quiz data is empty or undefined.");
            return;
        }

        const currentQuestion = quizData[currentQuestionIndex];
        if (!currentQuestion) {
            console.error("Current question is undefined or out of bounds.");
            return;
        }

        const userAttemptData = {
            questionId: currentQuestion.question_id,
            attemptStatus: 'un_attempt',
        };

        setSkippedCount((prev) => prev + 1); // Increment skipped count for each skip action

        try {
            setLoading(true);
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (err) {
            if (err.response?.status === 401) {
                console.log('Navigate to login due to 401');
                navigate('/');
            }
            console.error('Error submitting user attempt in handleSkip:', err);
        } finally {
            setLoading(false);
        }
        window.scrollTo({
            top: 0,      // Scroll to the top
            behavior: 'smooth', // Smooth scrolling animation
        });
        // Check if it's the last question or the end of the current set
        const isLastQuestion = currentQuestionIndex === quizData.length - 1;
        const remainingQuestions = quizData.length - (currentQuestionIndex + 1);
        const isEndOfSet = remainingQuestions === 0; // Updated condition for end of set

        if (isEndOfSet || isLastQuestion) {
            navigate('/learning-quiz-result', {
                state: {
                    correctCount: 0,
                    incorrectCount: 0,
                    category_id,
                    level_id,
                    categoryName,
                    total_time_spent,
                    skippedCount: skippedCount + 1, // Pass the updated skippedCount when navigating
                    quizTypeId,
                    quizName
                },
            });
        } else {
            handleNextQuestion(); // Continue to the next question
        }
    };


    const handleSureMove = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const userAttemptData = {
            questionId: currentQuestion.question_id,
            attemptStatus: 'confirm',
        };

        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            setAttemptStatus(response.data.message.attempt.attempt_status);
            console.log(response?.data?.message?.attempt.attempt_status, "New Check confirm")
            // setAttemptStatus22(response?.data?.message);
        } catch (err) {
            if (err.response?.status === 401) {
                console.log('Navigate to login due to 401');
                navigate('/');
            }
            console.error('Error submitting user attempt:', err);
        }
        setShowSubmitMessage(false);
        setSelectedOption(null);
        setIsSubmitted(false);
        setShowResultButtons(false); // Reset to initial state
        setIsAnswerCorrect(null);
        const isLastQuestion = currentQuestionIndex === quizData.length - 1;
        const isEndOfSet = (currentQuestionIndex + 1) % 6 === 0 || !hasMoreQuestions;

        if (isEndOfSet || isLastQuestion) {
            navigate('/learning-quiz-result', {
                state: {
                    category_id,
                    level_id,
                    categoryName,
                    total_time_spent,
                    correctCount,
                    incorrectCount,
                    skippedCount,
                    quizTypeId,
                    quizName
                },
            });
        } else {
            handleNextQuestion();
        }
    };

    const handeReattempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const userAttemptData = {
            questionId: currentQuestion.question_id,
            attemptStatus: 're_attempt',
        };

        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (err) {
            if (err.response?.status === 401) {
                console.log('Navigate to login due to 401');
                navigate('/');
            }
            console.error('Error submitting user attempt:', err);
        }
        setShowSubmitMessage(false);
        setSelectedOption(null);
        setIsSubmitted(false);
        setShowResultButtons(false); // Reset to initial state
        setIsAnswerCorrect(null);
        const isLastQuestion = currentQuestionIndex === quizData.length - 1;
        const isEndOfSet =
            (currentQuestionIndex + 1) % 6 === 0 || !hasMoreQuestions;

        if (isEndOfSet || isLastQuestion) {
            navigate('/learning-quiz-result', {
                state: {
                    category_id,
                    level_id,
                    categoryName,
                    total_time_spent,
                    correctCount,
                    incorrectCount,
                    skippedCount,
                    quizTypeId,
                    quizName,
                },
            });
        } else {
            handleNextQuestion();
        }
    };
    useEffect(() => {
        if (!isLoading && quizData.length === 0) {

            navigate("/coming-soon");
        }
    }, [isLoading, currentQuestion, navigate]);
    const progressWidth = ((currentQuestion + 1) / quizData.length) * 100;
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    if (isLoadingImage) {

    }
    return (
        <div className='Profile_Design_Main_Div_11 mock-reading-quiz-page'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>
                                {showResultButtons
                                    ? Translate?.message?.data?.quizResult || "Quiz Result"
                                    : Translate?.message?.data?.quiz || "Quiz"}
                            </h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container JLPT_Quiz" style={{ marginTop: "75px", marginBottom: "75px", height: "auto" }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            {isLoadingImage ? (
                                <div className="quiz-loading">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                        alt="Loading..."
                                        className="lecture-video-placeholder"
                                    />
                                </div>
                            ) : (
                                <div
                                    className={`quiz-container ${isSubmitted ? "left" : ""}`}

                                >

                                    <div className="quiz-header">
                                        <div className="quiz-info">
                                            <span>{currentQuestionIndex + 1}/{quizData.length}</span>
                                        </div>
                                        <div className="quiz-timer">
                                            <span>{formatTime(timeSpent)}</span>
                                        </div>
                                    </div>
                                    <div className="progress-bar-container" style={{ backgroundColor: 'gray', height: '10px', borderRadius: '5px' }}>
                                        <div
                                            className="progress-bar"
                                            style={{
                                                width: `${progressPercentage}%`,
                                                backgroundColor: '#ffc0cb',
                                                height: '100%',
                                                borderRadius: '5px',
                                            }}
                                        ></div>
                                    </div>

                                    <div className="quiz-question">
                                        <div className="quiz-header">
                                            <h6>{Translate?.message?.data?.selectTheCorrectTranslation || "Select the correct translation"}</h6>
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                {currentQuestion && (currentQuestion.ai_english_explain || currentQuestion.ai_hindi_explain) && (
                                                    <button
                                                        className="quiz-help-ai-button"
                                                        onClick={openAiModal}
                                                    >
                                                        Help AI
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                        {currentQuestion?.question_image && (
                                            <div className="quiz-question-container" style={{ marginBottom: '10px' }}>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/question15.png`}
                                                    alt="icon"
                                                    className="question-icon"
                                                />
                                                <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                    <p style={{ marginBottom: '6px', fontWeight: 600 }}>Question Image</p>
                                                    <div
                                                        style={{
                                                            maxHeight: '280px',
                                                            overflowY: 'auto',
                                                            border: '1px solid #e5e7eb',
                                                            borderRadius: '10px',
                                                            padding: '4px',
                                                            background: '#fff',
                                                        }}
                                                    >
                                                        <img
                                                            src={currentQuestion.question_image}
                                                            alt="Question"
                                                            style={{ maxWidth: '100%', borderRadius: '8px', objectFit: 'contain' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="quiz-question-container">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/assets/images/question15.png`}
                                                alt="icon"
                                                className="question-icon"
                                            />
                                            <div className="quiz-question-box">
                                                <h7>{currentQuestion?.question_text || "Question not available"}</h7>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="quiz-options-container">
                                        <div className="quiz-options">
                                            {currentQuestion?.options?.length > 0 ? (
                                                currentQuestion.options.map((option) => (
                                                    <button
                                                        key={option.option_id}
                                                        className={`quiz-option ${selectedOption === option.option_id
                                                            ? isSubmitted && isCorrect === true
                                                                ? 'correct' // Apply correct class if the option is correct
                                                                : isSubmitted && isCorrect === false
                                                                    ? 'incorrect' // Apply incorrect class if the option is incorrect
                                                                    : 'selected' // Apply selected class if the option is selected
                                                            : ''
                                                            }`}
                                                        onClick={() => handleSelect(option.option_id)}
                                                        disabled={isSubmitted} // After submit, lock options; before submit, allow changes
                                                    >
                                                        <span
                                                            className={`quiz-option-text ${selectedOption === option.option_id
                                                                ? 'selected-text' // Apply selected-text class if the option is selected
                                                                : ''
                                                                }`}
                                                        >
                                                            {option.option_text || 'Option'} {/* Fallback text for option */}
                                                        </span>

                                                        {/* Feedback messages displayed only after submission */}
                                                        {isSubmitted && selectedOption === option.option_id && isCorrect === false && (
                                                            <span className="responsive-incorrect">
                                                                <CloseIcon className="quiz-close-icon" />
                                                                {Translate?.message?.data?.incorrect || "Incorrect"}
                                                            </span>
                                                        )}

                                                        {isSubmitted && selectedOption === option.option_id && isCorrect === true && (
                                                            <span className="responsive-correct">
                                                                <RadioButtonUncheckedIcon
                                                                    className="quiz-checked-icon"
                                                                />
                                                                {Translate?.message?.data?.correct || "Correct"}
                                                            </span>
                                                        )}
                                                    </button>
                                                ))
                                            ) : (
                                                <p>Loading...</p> // Fallback UI for no options
                                            )}
                                            {showSelectAnswerMessage && (
                                                <h7 style={{
                                                    color: 'red',
                                                    marginTop: 5,
                                                    textAlign: 'left', // Align the text to the right
                                                }}>
                                                    {Translate?.message?.data?.pleaseSelectAnAnswer || " Please select an answer."}
                                                </h7>
                                            )}




                                        </div>
                                    </div>
                                    <div className="quiz-controls">
                                        <div className="quiz-buttons">
                                            {showResultButtons ? (
                                                isCorrect ? (
                                                    <>
                                                        {/* Explanation Box */}
                                                        <div className="quiz-content">
                                                            <div className={`explanation-corect-box-readquiz ${!currentQuestion?.text_explanation && !currentQuestion?.image_explanation && !currentQuestion?.options?.[0]?.option_description ? 'hidden' : ''}`}>
                                                                <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>

                                                                {currentQuestion?.image_explanation && (
                                                                    <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                        <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                                            <p style={{ marginBottom: '4px', fontWeight: 600 }}>Image Explanation</p>
                                                                            <div style={{ maxHeight: '200px', maxWidth: '400px', overflow: 'auto' }}>
                                                                                <img
                                                                                    src={currentQuestion.image_explanation}
                                                                                    alt="Image explanation"
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        maxHeight: '280px',
                                                                                        objectFit: 'contain',
                                                                                        borderRadius: '8px'
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {currentQuestion?.text_explanation && (
                                                                    <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                        <div className="quiz-question-box" style={{ textAlign: 'left', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                                            <p style={{ marginBottom: '4px', fontWeight: 600 }}>Text Explanation</p>
                                                                            <p style={{ marginBottom: 0 }}>{currentQuestion.text_explanation}</p>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {currentQuestion?.options?.[0]?.option_description && currentQuestion?.options?.map((option, i) => (
                                                                    <div key={i} className="explanation-item">
                                                                        <span>{option?.option_description}</span>
                                                                    </div>
                                                                ))}
                                                            </div>


                                                            {/* Buttons for Correct Answer */}
                                                            <div
                                                                className={`result-buttons-correct ${!currentQuestion?.text_explanation && !currentQuestion?.image_explanation && !currentQuestion?.options?.[0]?.option_description ? 'no-explanation' : ''
                                                                    }`}
                                                            >
                                                                <button className="quiz-submit" onClick={handleSureMove}>
                                                                    {Translate?.message?.data?.dontWantToReattempt || "Don’t Want to Reattempt"}
                                                                    <div className="reattempt-icon">
                                                                        <GrEmptyCircle size={20} color="white" />
                                                                    </div>
                                                                </button>


                                                                <button className="quiz-submit" onClick={handeReattempt}>
                                                                    {Translate?.message?.data?.wantToReattempt || "Want to Reattempt"}
                                                                    <div className="want-reattempt-icon">
                                                                        <IoTriangleOutline size={20} color="white" />
                                                                    </div>
                                                                </button>

                                                                <button className="quiz-submit" onClick={handleStartNewQuiz}>
                                                                    {Translate?.message?.data?.moveToNext || "Move to Next"}
                                                                </button>

                                                                <button className="quiz-submit" onClick={() => navigate("/")}>
                                                                    {Translate?.message?.data?.backToHome || "Back to Home"}
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {/* Explanation Box */}
                                                        {(currentQuestion?.text_explanation || currentQuestion?.image_explanation || currentQuestion?.options?.[0]?.option_description) && (
                                                            <div className="explanation-incorect-box-readquiz">
                                                                <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>

                                                                {currentQuestion?.image_explanation && (
                                                                    <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                        <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                                            <p style={{ marginBottom: '4px', fontWeight: 600 }}>Image Explanation</p>
                                                                            <div
                                                                                style={{
                                                                                    maxHeight: '280px',
                                                                                    maxWidth: '280px',
                                                                                    overflowY: 'auto',
                                                                                    border: '1px solid #e5e7eb',
                                                                                    borderRadius: '10px',
                                                                                    padding: '4px',
                                                                                    background: '#fff',
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={currentQuestion.image_explanation}
                                                                                    alt="Image explanation"
                                                                                    style={{ maxWidth: '100%', borderRadius: '8px', objectFit: 'contain' }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {currentQuestion?.text_explanation && (
                                                                    <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                        <div className="quiz-question-box" style={{ textAlign: 'left', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                                            <p style={{ marginBottom: '4px', fontWeight: 600 }}>Text Explanation</p>
                                                                            <p style={{ marginBottom: 0 }}>{currentQuestion.text_explanation}</p>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {currentQuestion?.options?.[0]?.option_description && currentQuestion?.options?.map((option, i) => (
                                                                    <div key={i} className="explanation-item">
                                                                        <span>{option?.option_description}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* Buttons for Incorrect Answer */}
                                                        <div className="result-buttons-incorrect">
                                                            <button className="quiz-submit" onClick={handleStartNewQuiz}>
                                                                {Translate?.message?.data?.moveToNext || "Move to Next"}
                                                            </button>

                                                            <button className="quiz-submit" onClick={() => navigate("/")}>
                                                                {Translate?.message?.data?.backToHome || "Back to Home"}
                                                            </button>
                                                        </div>
                                                    </>
                                                )
                                            ) : (
                                                <>
                                                    {/* Initial Buttons */}
                                                    <div>
                                                        {loading ? (
                                                            // Show a loading state for the button
                                                            <button
                                                                className="quiz-submit"
                                                                style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                                disabled
                                                            >
                                                                {Translate?.message?.data?.loading || "Loading..."}
                                                            </button>
                                                        ) : (
                                                            <>
                                                                {currentQuestion?.length >= 6 ? (
                                                                    // Render the button without any action if the condition is met
                                                                    <>

                                                                        <button
                                                                            className="quiz-submit"
                                                                            style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                                            disabled
                                                                        >
                                                                            {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                        </button>

                                                                    </>
                                                                ) : (
                                                                    // Render the button with the onClick handler for skipping
                                                                    <>

                                                                        <button
                                                                            className="quiz-submit"
                                                                            onClick={handleSkip}
                                                                            style={{ backgroundColor: "White" }}
                                                                        >
                                                                            {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                        </button>

                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                    <div>

                                                        <button className="quiz-submit" onClick={() => handleSubmit()}>
                                                            {Translate?.message?.data?.submit || "Submit"}
                                                        </button>

                                                    </div>
                                                </>
                                            )}


                                        </div>
                                    </div>


                                </div>

                            )}
                        </div>
                    </div>
                </div>
            </div>

            {isAiModalOpen && (
                <div className="help-ai-modal-overlay" onClick={closeAiModal}>
                    <div
                        className="help-ai-modal"
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div className="help-ai-modal-header">
                            <h3>Help AI</h3>
                            <button className="help-ai-close-button" onClick={closeAiModal}>
                                ×
                            </button>
                        </div>
                        <div className="help-ai-modal-toolbar">
                            <button
                                className={`help-ai-toggle-button ${aiLanguage === "english" ? "active" : ""}`}
                                onClick={() => setAiLanguage("english")}
                                disabled={!quizData[currentQuestionIndex]?.ai_english_explain}
                            >
                                English
                            </button>
                            <button
                                className={`help-ai-toggle-button ${aiLanguage === "hindi" ? "active" : ""}`}
                                onClick={() => setAiLanguage("hindi")}
                                disabled={!quizData[currentQuestionIndex]?.ai_hindi_explain}
                            >
                                Hindi
                            </button>
                            <button
                                className="help-ai-sound-button"
                                onClick={() => {
                                    const current = quizData[currentQuestionIndex];
                                    if (!current) return;
                                    if (aiLanguage === "english") {
                                        speakText(current.ai_english_explain, "en-US");
                                    } else {
                                        speakHindiExplainWithJapanese(current.ai_hindi_explain);
                                    }
                                }}
                            >
                                <VolumeUpIcon />
                            </button>
                        </div>
                        <div className="help-ai-modal-body">
                            {aiLanguage === "english"
                                ? renderWithBold(
                                    quizData[currentQuestionIndex]?.ai_english_explain ||
                                    "No English explanation available."
                                )
                                : renderWithBold(
                                    quizData[currentQuestionIndex]?.ai_hindi_explain ||
                                    "No Hindi explanation available."
                                )}
                        </div>
                    </div>
                </div>
            )}
      <Footer />
    </div>
  );
}
export default MockTestReadingQuiz;
